module.exports = __webpack_public_path__ + "c7382d5b98eeb31509551b90ee649d33.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-23.png
// module id = 2464
// module chunks = 0